import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const COLORS = [
  "#B3C100",
  "#1F3F49",
  "#EA6A47",
  "#6AB187",
  "#488A99",
  "#DBAE58",
  "#0091D5",
  "#8D6E63",
  "#26A69A",
];

type CasePieChartProps = {
  pieData?: {
    status: string;
    data: {
      count: number;
      percent: string;
    };
  }[];
};

const CasePieChart: React.FC<CasePieChartProps> = ({ pieData = [] }) => {
  const chartData = pieData
    .filter((item) => item.data.count > 0) // optionally skip 0-count entries
    .map((item) => ({
      name: item.status,
      value: item.data.count,
    }));

  return (
    <div style={{ width: "100%", height: 300 }}>
      {chartData.length > 0 ? (
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              outerRadius={100}
              dataKey="value"
              label={({ name, percent }) =>
                `${name} ${(percent * 100).toFixed(0)}%`
              }
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <div
          style={{
            textAlign: "center",
            paddingTop: "100px",
            color: "#999",
            fontSize: "14px",
          }}
        >
          No Data Available
        </div>
      )}
    </div>
  );
};

export default CasePieChart;
